import OdinLogo from '@assets/icons/odin.webp'
import BottomSheet from '@components/BottomSheet'
import DfinityLogo from '@plug-core/assets/icons/dfinity.png'
import HyperliquidLogo from '@plug-core/assets/icons/hyperevm.svg'
import ICPSwapLogo from '@plug-core/assets/icons/icpswap.png'
import JupiterLogo from '@plug-core/assets/icons/jupiter.png'
import LiFiLogo from '@plug-core/assets/icons/lifi.jpeg'
import OneSecLogo from '@plug-core/assets/icons/onesec.png'
import StealthExLogo from '@plug-core/assets/icons/stealthex.png'
import YusanLogo from '@plug-core/assets/icons/yusan.png'
import { UNKNOWN_ERROR } from '@plug-core/constants/swapErrors'
import { SwapProvider } from '@plug-core/interfaces/swapInterface'
import { useSwapContext } from '@plug-core/providers/SwapProvider'
import { Avatar, ListGroup, ListRow, Text } from '@ui'
import React, { type FC } from 'react'

const SWAP_PROVIDER_LOGO_MAP = {
  [SwapProvider.ICPSWAP]: ICPSwapLogo,
  [SwapProvider.ODIN]: OdinLogo,
  [SwapProvider.JUPITER]: JupiterLogo,
  [SwapProvider.LIFI]: LiFiLogo,
  [SwapProvider.STEALTHEX]: StealthExLogo,
  [SwapProvider.ONESEC]: OneSecLogo,
  [SwapProvider.DFINITY]: DfinityLogo,
  [SwapProvider.YUSAN]: YusanLogo,
  [SwapProvider.HYPERLIQUID]: HyperliquidLogo,
}

type Props = {
  visible: boolean
  onClose: () => void
}

export const SwapProviderSelect: FC<Props> = ({ visible, onClose }) => {
  const { quotes, selectedProvider, setManualProvider, quoteFetchErrors } = useSwapContext()

  const renderProviders = () => {
    return (
      <ListGroup>
        {quotes.map(({ priceHuman, provider }) => {
          const isSelected = selectedProvider === provider

          return (
            <ListRow
              key={provider}
              onClick={() => {
                setManualProvider(provider)
                onClose()
              }}
              selected={isSelected}
              leading={<Avatar src={SWAP_PROVIDER_LOGO_MAP[provider]} fallback={provider} />}
              primary={provider}
              secondary={<span className="tabular">{priceHuman.toFixed(8)}</span>}
              trailing={
                <Text as="span" variant="label" tone={isSelected ? 'success' : 'fg-2'}>
                  {isSelected ? 'Selected' : 'Select'}
                </Text>
              }
            />
          )
        })}

        {quoteFetchErrors
          .filter((e) => e.error !== UNKNOWN_ERROR)
          .map(({ error, provider }) => (
            <ListRow
              key={provider}
              leading={<Avatar src={SWAP_PROVIDER_LOGO_MAP[provider]} fallback={provider} />}
              primary={provider}
              secondary={<span className="whitespace-normal">{error}</span>}
            />
          ))}
      </ListGroup>
    )
  }

  return (
    <BottomSheet visible={visible} onBackdropClick={onClose}>
      {renderProviders()}
    </BottomSheet>
  )
}
